import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { reportErrorMessage } from "#/utils/ErrorReporting"
import { PhoneSupportNumber } from "#/lib/carrot-api/types/PhoneNumber"
import { CountryCode } from "#/utils/CountryCode"
import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"
import useGetMemberCountry from "#/components/company/hooks/useGetMemberCountry"

const phoneSupportNumberQueryKey = "getPhoneSupportNumber"

function useGetPhoneSupportNumber(
  companyId: number,
  countryCode: CountryCode
): UseQueryResult<PhoneSupportNumber, ResponseError> {
  return useQuery<PhoneSupportNumber, ResponseError>(
    [phoneSupportNumberQueryKey, countryCode],
    () => carrotClient.getPhoneSupportNumber({ companyId, countryCode }),
    {
      enabled: !!companyId && !!countryCode,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(3),
      onError: (error) =>
        reportErrorMessage(
          `Failed to fetch phone number for company ${companyId} and countryCode ${countryCode}, error: ${error}`
        )
    }
  )
}

export function useGetPhoneSupportNumberForUser(): UseQueryResult<PhoneSupportNumber, ResponseError> {
  const memberUserCountry = useGetMemberCountry()
  const memberUserCompany = useGetMemberCompany()

  return useGetPhoneSupportNumber(memberUserCompany?.data?.companyId, memberUserCountry?.data?.countryCode)
}
